import * as Linking from 'expo-linking';
import * as WebBrowser from 'expo-web-browser';
import { partnerSupplierAppURL } from '@/utils/environment';
import { Platform } from 'react-native';

const hostname = __DEV__ ? 'http://localhost:3000' : partnerSupplierAppURL;

/**
 * Open the unauthed Plaid Linking page of the app in a new browser.
 *
 * This works around OAuth requirements of Plaid, which do not support
 * Expo apps without ejecting. Instead, we do all Plaid operations in
 * the browser and redirect the user back to the app when complete.
 *
 * @param sessionToken Plaid Session token generated by Shishito
 * @returns Promise resolving when browser is closed
 */
export const openPlaidInBrowser = async (sessionToken: string) => {
  const returnUrl = Linking.createURL('redirect_from_plaid');

  return await WebBrowser.openAuthSessionAsync(
    `${hostname}/plaid-link?returnUrl=${returnUrl}&sessionToken=${sessionToken}&platform=${Platform.OS}`,
    returnUrl,
  );
};
